

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import qs from 'qs'
import MetaInfo from 'vue-meta-info'
import VueClipboard from 'vue-clipboard2'
import Calendar from 'vue-mobile-calendar'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'


Vue.qs = qs
Vue.use(AjaxPlugin)
Vue.use(WechatPlugin)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(AlertPlugin)
Vue.use(Calendar)

Vue.use(VueClipboard)

Vue.use(MetaInfo)

Vue.prototype.$getCurrentDatetime = function () {
var now = new Date()
var year = now.getFullYear() 
var month = now.getMonth()
var date = now.getDate()
var day = now.getDay()
var hour = now.getHours()
var minu = now.getMinutes()
var sec = now.getSeconds()
month = month + 1
if (month < 10) month = '0' + month
if (date < 10) date = '0' + date
if (hour < 10) hour = '0' + hour
if (minu < 10) minu = '0' + minu
if (sec < 10) sec = '0' + sec
return {
year, month, date, day, hour, minu, sec
}
}
Vue.prototype.$img2base64 = function (img) {
var canvas = document.createElement('canvas')
canvas.width = img.width
canvas.height = img.height
var ctx = canvas.getContext('2d')
ctx.drawImage(img, 0, 0, img.width, img.height)
var ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase()
var dataURL = canvas.toDataURL('image/' + ext)
return dataURL
}
Vue.config.productionTip = false

Vue.http = Vue.http.create({
baseURL: '//wx.jiuyiyishu.com/', // 基础url,如果是多环境配置这样写，也可以像下面一行的写死。

timeout: 3000 
})

Vue.http.interceptors.request.use((config) => {
let query = Vue.qs.parse(window.location.search.replace('?', ''))
config.headers['X-TOKEN'] = sessionStorage.getItem('x-token')
config.headers['STOREID'] = query.store_id
return config
}, function (error) {
return Promise.reject(error)
})

Vue.http.interceptors.response.use(function (response) {
response.data.code = parseInt(response.data.code)
return response.data
}, function (error) {

console.warn('error: ', error.code)
var originalRequest = error.config
if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1 && !originalRequest._retry) {
Vue.$vux.toast.show({
type: 'text',
width: '9.2em',
text: '当前网络信号不稳定\n建议切换4G/WiFi后重试'
})
originalRequest._retry = true
return Vue.http.request(originalRequest)
}
return Promise.reject(error)
})
Vue.prototype.$http = Vue.http

const FastClick = require('fastclick')
FastClick.attach(document.body)

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js